import { useContext, useLayoutEffect, type RefObject } from "react";

import { MayaAssistantComposerContext } from "../context/sidebar-context";

/**
 * Called by the full AI Assistant page with its composer. Maya's launcher
 * then knows where Maya is on that page: ⌘K focuses this composer, a tap on
 * the launcher makes it glow, the launcher keeps clear of it, and the warp
 * lands in it when the sidebar closes on arrival. Does nothing outside the
 * app layout.
 */
export const useMayaAssistantComposer = (
  inputRef: RefObject<HTMLTextAreaElement | null>,
) => {
  const composerRef = useContext(MayaAssistantComposerContext);
  useLayoutEffect(() => {
    if (!composerRef) return;
    composerRef.current = { inputRef };
    return () => {
      composerRef.current = null;
    };
  }, [composerRef, inputRef]);
};
